const MIN_PERCENTAGE_TO_SHOW = 0.001;

export { MIN_PERCENTAGE_TO_SHOW };
